import { useEffect, useState } from "react";
import { MoonIcon, SunIcon } from "../assets/svgs/svgs";

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const root = window.document.documentElement;
    const stored = localStorage.getItem("theme");
    const dark =
      stored === "dark" ||
      (!stored && window.matchMedia("(prefers-color-scheme: dark)").matches);

    if (dark) {
      root.classList.add("dark");
      setIsDark(true);
    } else {
      root.classList.remove("dark");
    }
  }, []);

  const toggleTheme = () => {
    const root = window.document.documentElement;
    if (isDark) {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
      setIsDark(false);
    } else {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
      setIsDark(true);
    }
  };

  return (
    // <button
    //   onClick={toggleTheme}
    //   className="fixed top-4 right-4 z-50 p-2 text-sm bg-accent-light dark:bg-accent-dark text-white rounded"
    // >
    //   {isDark ? "Light Mode" : "Dark Mode"}
    // </button>

    <button
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={isDark}
      className="fixed top-4 right-4 z-50 p-2"
    >
      <SunIcon
        className={`h-9 w-9 transition-all duration-200 motion-reduce:transition-none
                dark:text-accent-dark
                ${
                  isDark
                    ? "opacity-100 scale-100 rotate-0"
                    : "opacity-0 scale-90 rotate-90"
                }`}
      />

      {/* Moon shows in LIGHT mode; make it dark/purple */}
      <MoonIcon
        className={`h-9 w-9 absolute inset-0 m-auto transition-all duration-200 motion-reduce:transition-none
                text-text-light
                ${
                  isDark
                    ? "opacity-0 scale-90 -rotate-90"
                    : "opacity-100 scale-100 rotate-0"
                }`}
      />
    </button>
  );
}
